//SUPPLIER
export const ALL_SUPPLIER_REQUEST = "ALL_SUPPLIER_REQUEST";
export const ALL_SUPPLIER_SUCCESS = "ALL_SUPPLIER_SUCCESS";
export const ALL_SUPPLIER_FAIL = "ALL_SUPPLIER_FAIL";

export const ALL_SUPPLIER_COMPANY_REQUEST = "ALL_SUPPLIER_COMPANY_REQUEST";
export const ALL_SUPPLIER_COMPANY_SUCCESS = "ALL_SUPPLIER_COMPANY_SUCCESS";
export const ALL_SUPPLIER_COMPANY_FAIL = "ALL_SUPPLIER_COMPANY_FAIL";
